module.exports = __webpack_public_path__ + "img/amex.07bc54fe.png";